<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des workflows</h2>
    <p class="page-subtitle">Définissez les étapes de validation des projets</p>
  </div>
  <button (click)="openCreatePage()" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau workflow
  </button>
</div>

@if (errorMessage) {
<div class="alert alert-error mb-4">
  {{ errorMessage }}
  <button class="close-alert" (click)="errorMessage = ''">×</button>
</div>
}
@if (successMessage) {
<div class="alert alert-success mb-4">
  {{ successMessage }}
  <button class="close-alert" (click)="successMessage = ''">×</button>
</div>
}

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Rechercher un workflow..."
          class="search-input"
        >
      </div>
      <select class="filter-select" [ngModel]="statusFilter" (ngModelChange)="onStatusFilterChange($event)">
        <option value="ALL">Tous les statuts</option>
        @for (status of workflowStatusOptions; track status) {
          <option [value]="status">{{ status }}</option>
        }
      </select>
      <select class="filter-select" [ngModel]="typeFilter" (ngModelChange)="onTypeFilterChange($event)">
        @for (type of workflowTypeOptions; track type) {
          <option [value]="type">{{ type === 'ALL' ? 'Tout' : type }}</option>
        }
      </select>
    </div>
  </div>
  <div class="table-responsive">
    <table class="modern-table">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Type</th>
          <th>Statut</th>
          <th>Étapes</th>
          <th>Description</th>
          <th class="actions-cell">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (workflow of workflows; track workflow.id) {
        <tr class="clickable-row" (click)="openEditPage(workflow)">
          <td class="font-bold">{{ workflow.name }}</td>
          <td>{{ workflow.type || 'PROJECT' }}</td>
          <td>
            <span class="wf-badge" [attr.data-status]="workflow.status">{{ workflow.status }}</span>
          </td>
          <td>{{ workflow.steps.length || 0 }}</td>
          <td>{{ workflow.description || '-' }}</td>
          <td class="actions-cell">
            <div class="actions-wrapper">
              <button (click)="$event.stopPropagation(); createVersion(workflow)" class="btn-icon" title="Créer une version">
                <mat-icon aria-hidden="true">content_copy</mat-icon>
              </button>
            </div>
          </td>
        </tr>
        } @empty {
        <tr class="empty-row">
          <td colspan="6">
            <div class="empty-state">
              <mat-icon class="empty-icon" aria-hidden="true">tune</mat-icon>
              <p>Aucun workflow configuré</p>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
